import React from 'react';
import { useSelector } from 'react-redux';

// Constants
import { meetingItemTypes } from 'Shared/constants/constants';

// Helpers
import WorkspaceRecentUpdatesHelper from 'Shared/model_helpers/WorkspaceRecentUpdates.helper';
import MeetingItemHelpers from 'Shared/model_helpers/MeetingItem.helper';

// Selectors
import * as meetingItemSelectors from 'Shared/selectors/MeetingItems.selectors';

// Components
import NotificationHeader from './partials/NotificationHeader';
import NotificationMeetingItem from './partials/NotificationMeetingItem';

// Hooks
import { useCurrentUser } from 'Shared/utils/hooks/use-current-user';

type Props = {
  notification;
};

const NewItemAssigned = ({ notification }: Props) => {
  const meetingItemUuid = WorkspaceRecentUpdatesHelper.getMeetingItemUuid(notification);
  const assigneeName = WorkspaceRecentUpdatesHelper.getAssigneeName(notification);

  const { user } = useCurrentUser();
  const userFullName = user.full_name;
  const isUserAssignee = assigneeName === userFullName;

  const meetingItem = useSelector(state => meetingItemSelectors.getMeetingItemByUuid(state, { meetingItemUuid })).get(
    meetingItemUuid
  );
  const itemType = MeetingItemHelpers.getItemType(meetingItem);

  if (!meetingItem) return null;

  const label = `assigned a ${meetingItemTypes[itemType].toLowerCase()} to ${isUserAssignee ? 'you' : assigneeName}`;

  const baseClassName = 'NewItemAssigned';

  return (
    <div className={baseClassName}>
      <NotificationHeader notification={notification} label={label} />
      <NotificationMeetingItem meetingItem={meetingItem} />
    </div>
  );
};

export default NewItemAssigned;
